export enum AcquisitionChannelTypeEnum {
  PARTNERSHIP = 'Parceria Comercial',
  MARKETING = 'Marketing',
  ENERGISA = 'Originação Energisa',
  OUTBOUND_SELLER = 'Outbound Vendedor',
  OUTBOUND_PRE_SALES = 'Outbound Pré-Vendas',
  CUSTOMER_REFERRAL = 'Indicação Cliente',
  CLARKE_INDICATION = 'Indicação Clarke',
  UPSELL = 'Upsell',
  FIELD = 'Campo',
  INSIDE = 'Interno',
}

export enum DocTypeEnum {
  CNPJ = 'CNPJ',
  CPF = 'CPF',
}
